import React from 'react'
import "./AboutUs.css"
import C2wAboutLanding from './landingPage/AboutLandingPage'
import C2wAboutSir from './aboutSir/AboutSir'
import C2wAboutC2W from './aboutC2W/AboutC2W'
import C2wKeyFeatures from './keyFeatures/KeyFeatures'
import C2wAppIntro from '../../components/C2wHome/AppIntroAndReview/AppIntro/appIntro'
import C2wReviews from '../../components/C2wHome/AppIntroAndReview/Review/review'
import C2wLocation from './location/Location.js'
import C2wGoogleReviews from './googleReviews/GoogleReviews.js'
import Footer from '../c2wHomePage/Footer.js'
function C2wAboutUs() {
  return (
    <div className='C2wAboutUs'>
      <div className='C2wAboutUs_container'>
        <C2wAboutLanding />
        <C2wAboutSir />
        <C2wAboutC2W />
        <C2wKeyFeatures />
        <div className='C2wAboutUs_appintro'>
          <C2wAppIntro />
          <C2wReviews />
        </div>
        <C2wGoogleReviews />
        <C2wLocation />
        <div className="ADfooter__container">
          <Footer />
        </div>
      </div>

    </div>
  )
}

export default C2wAboutUs
